import { GoArrowRight } from "react-icons/go";
import { Link } from 'react-router-dom';
interface LinkItemProps {
    link: string;
    label: string;
    onClick?: () => void,
};
const LinkItem = (props: LinkItemProps) => {
    return (
        <Link to={props.link}>
            <li className='flex flex-row items-center gap-2 text-[13px] py-0.5' onClick={props.onClick}>
                <div className='flex items-center gap-2 px-2 py-0.5 rounded-sm transition-all duration-300 ease-in-out hover:ring-[1px] hover:px-4 hover:ring-green-400 hover:bg-green-100 hover:dark:bg-green-700 cursor-pointer'>
                    <GoArrowRight className='my-auto dark:text-slate-200' />
                    <span className='font-normal dark:text-slate-200'>{props.label}</span>
                </div>
            </li>
        </Link>
    )
}

export default LinkItem